import { BlogCategory } from '@shared/models/blog-category.model';
import { BlogService, TrackingService } from '@core/services';
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { environment } from '@env/environment';
import { GhGlobal } from '@shared/helpers/global-functions';

import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

const HOME_MENU: BlogCategory = {
  id: 0,
  position: 0,
  description: '',
  name: 'Blog',
  slug: '',
  color: '#ff5a5a',
  marker: `${environment.cdnPath}/svgs/1613408570166%40peep_32x32.svg`,
  active: '1',
  types: ['top-bar']
};

@Component({
    selector: 'gh-category-menu',
    templateUrl: 'category-menu.component.html',
    standalone: false
})

export class CategoryMenuComponent implements OnInit {
  isSearchOpened = false;
  categories = [];
  root = environment.root;

  constructor(
    public router: Router,
    @Inject(DOCUMENT) private document: Document,
    private blogService: BlogService,
    private trackingService: TrackingService,
  ) { }

  ngOnInit() {
    this.categories = [HOME_MENU];
    this.blogService.getCategories()
      .pipe(take(1))
      .subscribe((res: any) => {
        if (res && !res.error) {
          this.categories.push(...res);
          this.categories = this.categories.sort((p1: any, p2: any) => GhGlobal.compare(p1.position, p2.position, true));
        }
      });
  }

  toggleSearch() {
    this.isSearchOpened = !this.isSearchOpened;
    const el = this.document.body;
    if (this.isSearchOpened) {
      el.classList.add('search');
    } else {
      el.classList.remove('search');
    }
  }

  navClick(label: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'navigation',
      events: {
        click_text: label,
        feature: 'blog',
        environment: environment.env,
        location
      }
    });
  }

}
